<div class="chart">
	<ag-charts-angular [options]="options()"> </ag-charts-angular>
</div>
